<template>
    <div>
        <template v-if="fitmentSummary && fitments?.length > 0">
            <div class="fitment-count badge bg-dark text-uppercase fw-normal mt-2 cursor-pointer" @click="toggleInfoModalSummary()" data-bs-toggle="modal" data-bs-target="#infoModal">
                <p class="mb-0">{{ fitments.length }} oem fitment{{ fitments.length > 1 ? 's' : '' }}</p>
            </div>
        </template>
        <template v-else-if="fitments?.length > 0">
            <div class="fitments d-flex justify-content-center">
                <span v-for="fitment in fitments" class="mr-2" :key="fitment.id">
                    <img v-if="fitment.name && fitment.fitment_logo_url" 
                        class="cursor-pointer"
                        :src="fitment.fitment_logo_url.replace('.png', '.svg')"
                        width="30" 
                        height="30"
                        @click="toggleInfoModal(fitment)"
                        data-bs-toggle="modal" data-bs-target="#infoModal"
                    />
                </span>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['fitments', 'fitmentSummary'],
        methods: {
            async toggleInfoModal(fitment) {
                this.emitter.emit('openInfoModal', {heading: fitment.name, text: '<p>OE tyres on ' + fitment.name + ' vehicles are designed in tandem, meaning that sticking with the original equipment will maintain the optimal driving performance intended by the manufacturer.</p>'});
            },
            async toggleInfoModalSummary() {
                var heading = this.fitments.length + ' OEM fitment' + (this.fitments.length > 1 ? 's' : '');
                var text = '<p>' + this.fitmentNames + '</p>';

                this.emitter.emit('openInfoModal', {heading: heading, text: text});
            }
        },
        computed: {
            fitmentNames() {
                const names = [];

                _.forEach(this.fitments, function(fitment) {
                    names.push(fitment.name != null ? fitment.name : fitment.code);
                });

                return _join(names, ', ');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@frontendAssets/sass/_variables.scss';
    .fitments {
        span {
            float: left;
        }
    }
    .fitment-count {
        p {
            text-transform: uppercase;
            font-size: 12px;
            color: #fff;
            font-weight: 600;
        }
    }
</style>